import React from 'react';
import { useTranslation } from 'react-i18next';

const ExistingPrivacyPolicy = () => {
    const { t } = useTranslation();

    return (
        <div className="prose prose-invert max-w-none">
            <h1 className="text-center">{t('privacyPolicy.title')}</h1>
            <p className="text-sm text-center">{t('privacyPolicy.lastUpdated')}</p>

            <h2>{t('privacyPolicy.introduction.title')}</h2>
            <p>{t('privacyPolicy.introduction.content')}</p>

            <h2>{t('privacyPolicy.dataWeCollect.title')}</h2>
            <p>{t('privacyPolicy.dataWeCollect.description')}</p>
            <ul>
                <li><strong>{t('privacyPolicy.dataWeCollect.accountInfo.title')}</strong> {t('privacyPolicy.dataWeCollect.accountInfo.content')}</li>
                <li><strong>{t('privacyPolicy.dataWeCollect.userContent.title')}</strong> {t('privacyPolicy.dataWeCollect.userContent.content')}</li>
                <li><strong>{t('privacyPolicy.dataWeCollect.usageData.title')}</strong> {t('privacyPolicy.dataWeCollect.usageData.content')}</li>
                <li><strong>{t('privacyPolicy.dataWeCollect.locationData.title')}</strong> {t('privacyPolicy.dataWeCollect.locationData.content')}</li>
            </ul>

            <h2>{t('privacyPolicy.howWeUseData.title')}</h2>
            <p>{t('privacyPolicy.howWeUseData.description')}</p>
            <ul>
                <li>{t('privacyPolicy.howWeUseData.provideService')}</li>
                <li>{t('privacyPolicy.howWeUseData.personalize')}</li>
                <li>{t('privacyPolicy.howWeUseData.aiDevelopment')}</li>
                <li>{t('privacyPolicy.howWeUseData.safety')}</li>
            </ul>

            <h2>{t('privacyPolicy.dataSharing.title')}</h2>
            <p>{t('privacyPolicy.dataSharing.content')}</p>

            <h2>{t('privacyPolicy.dataSecurity.title')}</h2>
            <p>{t('privacyPolicy.dataSecurity.content')}</p>

            <h2>{t('privacyPolicy.yourRights.title')}</h2>
            <p>{t('privacyPolicy.yourRights.content')}</p>

            <h2>{t('privacyPolicy.contact.title')}</h2>
            <p>{t('privacyPolicy.contact.content', { email: '[Your Contact Email]' })}</p>
        </div>
    );
};

export default ExistingPrivacyPolicy;
